function isNotEmptyNumber(value: number | null | undefined): boolean {
  return value !== null && value !== undefined;
}

export default isNotEmptyNumber;
